var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBetaVersionInfoIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 15.1654C11.9581 15.1654 15.1667 11.9567 15.1667 7.9987C15.1667 4.04066 11.9581 0.832031 8.00004 0.832031C4.042 0.832031 0.833374 4.04066 0.833374 7.9987C0.833374 11.9567 4.042 15.1654 8.00004 15.1654Z",
    fill: "#3A82F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.1654C7.86739 11.1654 7.74022 11.1127 7.64645 11.0189C7.55268 10.9252 7.5 10.798 7.5 10.6654V7.33203C7.5 7.19942 7.55268 7.07225 7.64645 6.97848C7.74022 6.88471 7.86739 6.83203 8 6.83203C8.13261 6.83203 8.25978 6.88471 8.35355 6.97848C8.44732 7.07225 8.5 7.19942 8.5 7.33203V10.6654C8.5 10.798 8.44732 10.9252 8.35355 11.0189C8.25978 11.1127 8.13261 11.1654 8 11.1654Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 5.9974C8.36823 5.9974 8.66671 5.69892 8.66671 5.33073C8.66671 4.96254 8.36823 4.66406 8.00004 4.66406C7.63185 4.66406 7.33337 4.96254 7.33337 5.33073C7.33337 5.69892 7.63185 5.9974 8.00004 5.9974Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBetaVersionInfoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/beta_version_info_icon.3de6cf0b9824c3ec3e020d160525d84a.svg";